/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Card, CardContent } from "@mui/material";
// import tickicons from "../../assets/success1.png";

export default function SubmissionSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/development"); // Redirect to home after 5 seconds
    }, 5000);

    return () => clearTimeout(timer); // Clean up on unmount
  }, [navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: "100%",
          textAlign: "center",
          //   padding: 4,
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          {/* <Box
            sx={{
              width: 120,
              height: 120,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#e8f5e9",
              borderRadius: "50%",
              margin: "0 auto 24px",
              padding: 2,
            }}
          > */}
          <img
            src="/finishing.jpg"
            width={350}
            height={350}
            style={{ objectFit: "contain" }}
          />
          {/* </Box> */}

          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: "#2e7d32",
              mb: 2,
              mt: -7,
            }}
          >
            Submission Successful!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "18px",
              color: "text.secondary",
              mb: 3,
              lineHeight: 1.6,
            }}
          >
            Your application has been submitted successfully.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "text.disabled",
              fontStyle: "italic",
            }}
          >
            Thank you for your submission
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
